import gql from 'graphql-tag';

/** Client side query gets the demo athlete settings */
export const DemoAthleteQuery = gql`
    query DemoAthleteQuery {
        demoAthlete @client {
            activityStreamTypes
            autoplayAnimation
            id
            resolution
            selectedActivityStreamType
            unitsPreference
        }
    }
`;

/** Clieht side mutation saves demo athlete settings for the duration of the session */
export const DemoAthleteOptionsMutation = gql`
    mutation DemoAthleteOptionsMutation($input: AthleteOptionsInput!) {
        demoAthleteOptions(input: $input) @client {
            demoAthlete @client {
                activityStreamTypes
                autoplayAnimation
                id
                resolution
                selectedActivityStreamType
                unitsPreference
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/client/clientState/demoAthlete/queries.ts